// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { LayersInner } from "./LayersInner";
import {
  LayersInnerFromJSON,
  LayersInnerFromJSONTyped,
  LayersInnerToJSON,
  LayersInnerToJSONTyped,
} from "./LayersInner";

/**
 *
 * @export
 * @interface FolderInput
 */
export interface FolderInput {
  /**
   *
   */
  type?: FolderInputTypeEnum;
  /**
   *
   */
  name: string;
  /**
   *
   */
  layers?: Array<LayersInner>;
}

/**
 * @export
 */
export const FolderInputTypeEnum = {
  Folder: "folder",
} as const;
export type FolderInputTypeEnum = (typeof FolderInputTypeEnum)[keyof typeof FolderInputTypeEnum];

/**
 * Check if a given object implements the FolderInput interface.
 */
export function instanceOfFolderInput(value: object): value is FolderInput {
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function FolderInputFromJSON(json: any): FolderInput {
  return FolderInputFromJSONTyped(json, false);
}

export function FolderInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): FolderInput {
  if (json == null) {
    return json;
  }
  return {
    type: json["type"] == null ? undefined : json["type"],
    name: json["name"],
    layers:
      json["layers"] == null ? undefined : (json["layers"] as Array<any>).map(LayersInnerFromJSON),
  };
}

export function FolderInputToJSON(json: any): FolderInput {
  return FolderInputToJSONTyped(json, false);
}

export function FolderInputToJSONTyped(
  value?: FolderInput | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    type: value["type"],
    name: value["name"],
    layers:
      value["layers"] == null ? undefined : (value["layers"] as Array<any>).map(LayersInnerToJSON),
  };
}
